"use client";

import * as React from "react";
import { Sparkles } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface UseCaseItem {
  badge: string;
  image: string;
  title: string;
  problem: string;
  result: string;
}
const useCases: UseCaseItem[] = [{
  badge: "Atención al cliente",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/customer-service-agent-with-headset-smil-e5e202.png",
  title: "Atención desde el primer contacto",
  problem: "El cliente espera y se va.",
  result: "Respuesta inmediata y clientes más satisfechos."
}, {
  badge: "Cobranza",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/finance-professional-at-a-desk-viewing-a-df4e65.png",
  title: "Cobranza sin esfuerzo",
  problem: "Pagos atrasados y recordatorios hechos a mano.",
  result: "Avisos automáticos y el dinero entra a tiempo."
}, {
  badge: "Promoción y ventas",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/person-holding-a-smartphone-showing-a-wh-7b832c.png",
  title: "Información y promociones",
  problem: "Sus clientes no se enteran de sus productos.",
  result: "Mensajes y campañas por los canales que ya usan, con respuestas a sus preguntas."
}, {
  badge: "Agenda y citas",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/person-booking-an-appointment-on-a-smart-bca2a2.png",
  title: "Reservas sin complicaciones",
  problem: "Llamadas y mensajes para agendar cada cita.",
  result: "El cliente reserva, confirma y reprograma solo."
}, {
  badge: "Control de calidad",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/call-center-supervisor-with-headphones-r-38b95f.png",
  title: "Transcripción y análisis de llamadas",
  problem: "No sabe qué se dice a sus clientes.",
  result: "Cada llamada transcrita y analizada para corregir errores y mejorar el servicio."
}];
export default function Usageexamples() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="263729" id="ejemplos-de-uso" className="py-16 md:py-24 bg-background text-foreground scroll-mt-24">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-7xl flex flex-col items-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="flex flex-col items-center text-center mb-12 md:mb-16 max-w-3xl">
          <Badge variant="outline" className="mb-4 border-primary/30 text-primary gap-2 px-4 py-1.5 rounded-md bg-primary/5 uppercase font-medium tracking-wide">
            <Sparkles className="w-3.5 h-3.5" /> EJEMPLOS DE USO
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 font-default tracking-tight text-foreground">
            Así ayuda la IA en su día a día
          </h2>
          <p className="text-muted-foreground text-base md:text-lg font-default">
            Situaciones reales de una empresa que atiende clientes por WhatsApp, chat y teléfono.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full mb-12">
          {useCases.map((item, i) => <Card key={i} data-index={i} className={`bg-card border-border overflow-hidden flex flex-col rounded-md shadow-sm transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:border-primary ${i === 4 ? "md:col-span-2 lg:col-span-1" : ""}`}>
              <div className="aspect-[16/10] relative overflow-hidden bg-muted">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover rounded-t-md" loading="lazy" data-wvc-srcset={`${item.image}-wvc-srcset`} data-wvc-sizes={`${item.image}-wvc-sizes`} />
                <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent pointer-events-none" />
                <span className="absolute top-3 left-3 bg-background/90 backdrop-blur-xs text-xs font-semibold px-2.5 py-1 rounded-sm border border-border text-foreground shadow-2xs">
                  {item.badge}
                </span>
              </div>
              <CardContent className="p-6 flex-1 flex flex-col font-default text-left">
                <h3 className="text-xl font-bold text-foreground mb-4 font-default leading-snug">
                  {item.title}
                </h3>
                <div className="space-y-3 flex-1 text-sm">
                  <p className="text-muted-foreground">
                    <strong className="text-foreground font-semibold">Problema: </strong>
                    {item.problem}
                  </p>
                  <p className="text-muted-foreground">
                    <strong className="text-foreground font-semibold">Resultado: </strong>
                    {item.result}
                  </p>
                </div>
              </CardContent>
            </Card>)}
        </div>

        <div className="flex justify-center">
          <Link to="#contacto" className="inline-flex items-center justify-center bg-chart-4 hover:bg-chart-4/90 text-black font-bold px-8 py-4 text-base md:text-lg rounded-md shadow-md transition-all hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-chart-4 focus:ring-offset-2">
            Descubra dónde pierde dinero
          </Link>
        </div>
      </div>
    </section>;
}